import { lazy } from "react";
import { defineWebModule } from "@tc/ui";
import { manifest } from "./manifest.js";

const FinesPage = lazy(() => import("./web/FinesPage.js").then((m) => ({ default: m.FinesPage })));

export default defineWebModule({ manifest, pages: { "": FinesPage } });
